import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CardActualizacionMasiva from '../../../General/Excel/CardActualizacionMasiva';
import { putActualizacionMasivaBulkParcialApi } from '../../../../api/axios';
import { toast } from '../../../../utilities/appToast';
import {
    fileToTipoEnvioWizardRows,
    validateTipoEnvioWizardRow,
    buildActualizacionMasivaBulkParcialItems
} from '../../../../utilities/tipoEnvioMasivaBulkParcial';

const toastBulkParcialResponse = (data) => {
    const d = data ?? {};
    const errsObj = Array.isArray(d.errors) ? d.errors : [];
    const erroresTuples = Array.isArray(d.errores) ? d.errores : [];
    const pubs = Array.isArray(d.publicaciones) ? d.publicaciones : [];

    erroresTuples.slice(0, 25).forEach((t) => {
        if (typeof t === 'string') {
            toast.warn(t);
            return;
        }
        const a = t?.item1 ?? t?.Item1 ?? '';
        const b = t?.item2 ?? t?.Item2 ?? '';
        const line = [a, b].filter(Boolean).join(' — ');
        if (line) toast.warn(line);
    });

    errsObj.slice(0, 25).forEach((e) => {
        const id = e?.idPublicacion ?? e?.IdPublicacion;
        const msg = e?.errorMesage ?? e?.ErrorMesage ?? e?.message ?? e?.Message ?? '';
        const tgt = e?.target ?? e?.Target ?? '';
        const parts = [tgt, id != null ? `Id ${id}` : '', msg].filter(Boolean);
        toast.warn(parts.join(' · ') || JSON.stringify(e));
    });

    const okCount = pubs.length;
    const badCount = errsObj.length + erroresTuples.length;

    if (okCount > 0 && badCount === 0) {
        toast.success(`${okCount} publicación(es) actualizada(s) correctamente.`);
        return;
    }
    if (okCount > 0 && badCount > 0) {
        toast.success(`${okCount} publicación(es) actualizada(s).`);
        toast.warn(`${badCount} ítem(s) con incidencias (revisá los avisos anteriores).`);
        return;
    }
    if (badCount > 0) {
        toast.warn('La actualización finalizó con errores (revisá los avisos anteriores).');
        return;
    }
    toast.success('Tipo publicación y envío procesados.');
};

function ActualizacionMasivaTipoYEnvio({ idUsuario }) {
    const [file, setFile] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const isValidUpdateExcel = () => {
        if (!file) {
            toast.warn('No se ha seleccionado ningún archivo CSV');
            return false;
        }
        return true;
    };

    const exportExcel = async () => {
        if (!isValidUpdateExcel()) return;
        setIsLoading(true);
        try {
            const { rows, stats } = await fileToTipoEnvioWizardRows(file);

            if (stats.skippedNoId > 0) {
                toast.warn(
                    `${stats.skippedNoId} fila(s) tienen texto pero falta IdPublicacion/CodProducto en las columnas esperadas; no se incluyen en el envío.`
                );
            }
            const omitSinCambio = stats.skippedBlank + stats.skippedNoMutation;
            if (omitSinCambio > 0) {
                toast.info(
                    `Se omitieron ${omitSinCambio} fila(s) sin datos a aplicar (vacías debajo del encabezado o solo IdPublicacion sin otros campos).`
                );
            }

            if (!rows.length) {
                toast.warn(
                    'No quedaron filas para enviar: cada una debe tener IdPublicacion y al menos un campo a actualizar.'
                );
                return;
            }
            const invalidLines = [];
            rows.forEach((r, i) => {
                const e = validateTipoEnvioWizardRow(r);
                if (Object.keys(e).length > 0) invalidLines.push({ excelRow: i + 2, e });
            });
            if (invalidLines.length > 0) {
                const first = invalidLines[0];
                toast.warn(
                    `Hay ${invalidLines.length} fila(s) inválida(s). Ej. fila Excel ${first.excelRow}: ${Object.values(first.e)[0]}`
                );
                return;
            }

            const actualizacionMasivaBulk = buildActualizacionMasivaBulkParcialItems(rows);
            if (!actualizacionMasivaBulk.length) {
                toast.warn('No hay filas válidas para enviar (cada una debe tener IdPublicacion y algún dato a actualizar).');
                return;
            }
            const res = await putActualizacionMasivaBulkParcialApi({
                actualizacionMasivaBulk,
                idUser: Number(idUsuario) || 0
            });
            toastBulkParcialResponse(res?.data);
        } catch (err) {
            const data = err?.response?.data;
            if (data) {
                toastBulkParcialResponse(data);
            } else {
                toast.error('Las publicaciones no pudieron ser actualizadas.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="card p-4">
            <CardActualizacionMasiva
                title="Tipo Publicacion y Envío"
                btnText="Actualizar Tipo Publicacion y Envío"
                isLoading={isLoading}
                updateFile={setFile}
                exportExcel={exportExcel}
                isValidUpdateExcel={isValidUpdateExcel}
                tipoExcel={3}
                downloadName="Modelo Actualización TipoPub-Envio"
            >
                <div className="col-12 mb-3">
                    <p className="small text-muted mb-0">
                        Actualización masiva parcial: el servidor no valida ni exige los campos obligatorios del alta. En
                        cada fila podés dejar vacías las columnas que no cambien y cargar solo una o varias (además de
                        IdPublicacion).
                    </p>
                </div>
            </CardActualizacionMasiva>
        </div>
    );
}

ActualizacionMasivaTipoYEnvio.propTypes = {
    idUsuario: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

const mapStateToProps = (state) => ({
    idUsuario: state.general.userId
});

export default connect(mapStateToProps)(ActualizacionMasivaTipoYEnvio);
